export const FontFamily = {
  ADELL_SANS_THA: "AdelleSansTHA",
  THONG_LOR_SOI4: "ThonglorSoi4",
};

export const DisPlaySize = {
  XXL: "1536px",
  L: "1200px",
  XL: "1280px",
  LG: "1024px",
  MD: "768px",
  SM: "640px",
  S: "450px",
  SX: "400px",
  SS: "350px",
};

export const FontSize = {
  XXXS: "0.5rem",
  XXS: "0.625rem",
  XS: "0.75rem",
  SM: "0.875rem", // 14px
  BASE: "1rem", // 16px
  LG: "1.125rem",
  XL: "1.25rem",
  XXL: "1.5rem", // 24px
  "2XL": "1.625rem",
  "3XL": "2rem",
  "4XL": "2.5rem",
  "5XL": "3rem",
  "6XL": "4rem",
};

export const ColorPrimary = {
  RED_DARKER: "#511010",
  RED_DARK: "#BC2C1C",
  RED_BASE: "#FC3B26",
  RED_LIGHT: "#FFB6B1",
  RED_LIGHTER: "#FFEDEB",
  RED_WARM_GREY_BASE: "#F8F9EF",
};

export const ColorSecondary = {
  PINK_DARK: "#56053F",
  PINK_BASE: "#EE7BEE",
  PINK_LIGHT: "#F8C9F8",
  PINK_LIGHTER: "#FFF6FF",

  GREEN_DARK: "#044236",
  GREEN_BASE: "#50D77A",
  GREEN_LIGHT: "#96F4AE",
  GREEN_LIGHTER: "#E8FFEE",
  GREEN_WARM_GREY_BASE: "#F5FFF7",

  BLUE_DARK: "#042A45",
  BLUE_BASE: "#52A4FF",
  BLUE_LIGHT: "#9BDDFF",
  BLUE_LIGHTER: "#EBF8FF",
  BLUE_LIGHTER_ZERO: "#EBF8FF00",
  BLUE_WARM_GREY_BASE: "#F6FCFF",
  BLUE_LIGHT_CYAN: "#DFF4FF",

  RED_LIGHTER: "#FFEDEB00",
  RED_LIGHT_CYAN: "#FFE1DE",
};

export const ColorMain = {
  BLACK_MAIN: "#000000",
  BLACK: "#444443",
  DARK_GREY: "#696969",
  GREY: "#A0A0A0",
  LIGHT_GREY: "#E3E4E8",
  LIGHTER_GREY: "#F7F7F7",
  WHITE: "#FFFFFF",
};

export const ColorStatus = {
  GREEN_01: "#459947",
  GREEN_02: "#C9E1C9",
  GREEN_03: "#ECF5EF",

  ORANGE_01: "#F48900",
  ORANGE_02: "#F9BB6B",
  ORANGE_03: "#FEF3E6",

  RED_01: "#FF453A",
  RED_02: "#FFB6B1",
  RED_03: "#FFF5F5",
};

export const ColorGradient = {
  RED_0: "#DD3422",
  RED_50: "#ED3824",
  RED_100: "#FC3B26",
  RED2_0: "#BD2414",
  RED2_100: "#DD3422",
  DARK_RED_0: "#FC3B26",
  DARK_RED_100: "#FC6251",
  BLUE_0: "#5083D5",
  BLUE_100: "#64BCF7",
  GREEN_0: "#4FAC5C",
  GREEN_100: "#7BDA87",
  PINK_0: "#4F0F3D",
  PINK_100: "#E082E8",
  BLACK_0: "#2B292E",
  BLACK_100: "#5A575C",
  GREY_0: "#F7F7F8",
  GREY_100: "#FCFCFD",
  YELLOW_0: "#F8F9EF",
  YELLOW_100: "#FFFFFF",
};

export const PerkGradient = {
  perkGradient01: "#601810",
  perkGradient02: "#FF6A5A",
  perkGradient03: "#FFA79D",
  perkGradient04: "#D93321",
};

export const GotherCash = "#EEA20F";
